import classNames from 'classnames'
import { ButtonHTMLAttributes } from 'react'

export default function SelectorItem({
  children,
  className = '',
  isDisabled,
  isSelected,
  onClick,
}: {
  isDisabled?: boolean
  isSelected: boolean
} & ButtonHTMLAttributes<HTMLButtonElement>): React.ReactElement {
  const cx = classNames(
    'border-2',
    'border-blue-iris',
    'disabled:bg-gray-light',
    'disabled:border-gray-medium',
    'disabled:cursor-not-allowed',
    'disabled:opacity-50',
    'disabled:text-black-light',
    'font-medium',
    'p-3.5',
    'rounded',
    'text-blue-iris',
    'w-full',
    isSelected ? 'bg-green-lime' : 'bg-white',
  )

  return (
    <button className={`${cx} ${className}`} disabled={isDisabled} onClick={onClick} type="button">
      {children}
    </button>
  )
}
